import React from 'react'
import {
    Box,
    FormLabel,
    FormControlLabel,
    Checkbox,
    TextField,
    MenuItem,
    Typography,
    Divider,
    Alert,
} from '@mui/material'
import SelectList from '../../../../../Components/Elements/SelectList'
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector'
import {
    selectionControlLabelProps,
    selectionControlSx,
} from '@/Components/Elements/StyledComponents/Input'
import { BlockSettingsProps } from './types'

export const CountListOptionsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    if (!state.item.defDossier)
        return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>
    return (
        <Box sx={{ mt: 2 }}>
            <Box sx={{ mt: 2 }}>
                <FormLabel className={'required'}>
                    {kedo.t('List field')}
                </FormLabel>
                <SelectList
                    currentValue={state.item.settings.count_list_field}
                    onClear={() =>
                        handleChangeSettings('count_list_field', null)
                    }
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        page: 0,
                        limit: 200,
                        type: 'list',
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) => {
                        handleChangeSettings('count_list_field', item.id)
                    }}
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                <NivoSchemeSelector
                    kedo={kedo}
                    value={state.item.settings.scheme}
                    onChange={(e: any) =>
                        handleChangeSettings('scheme', e.target.value)
                    }
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                <FormLabel>
                    {kedo.t('Date')}{' '}
                    <Typography variant="caption">
                        {kedo.t('Optional')}
                    </Typography>
                </FormLabel>
                <SelectList
                    disableInit={true}
                    currentValue={state.item.settings.date_field}
                    onClear={() => handleChangeSettings('date_field', null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        type: 'date',
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) => {
                        handleChangeSettings('date_field', item.id)
                    }}
                />
            </Box>
            <FormControlLabel
                {...selectionControlLabelProps}
                control={
                    <Checkbox
                        size="small"
                        checked={state.item.settings.use_creation_date === true}
                        onChange={(e) => {
                            handleChangeSettings(
                                'use_creation_date',
                                e.target.checked
                            )
                        }}
                        sx={(theme) => selectionControlSx(theme)}
                    />
                }
                label={`${kedo.t('Use dossier creation date')} ${kedo.t(
                    'Optional'
                )}`}
                sx={{ ...selectionControlLabelProps.sx, mt: 2 }}
            />
            <Divider sx={{ my: 2 }} />
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Date format')}
                value={state.item.settings.date_format || ''}
                onChange={(e) =>
                    handleChangeSettings('date_format', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="year_month">{kedo.t('Year month')}</MenuItem>
                <MenuItem value="quarter">{kedo.t('Quarters')}</MenuItem>
                <MenuItem value="year">{kedo.t('Year')}</MenuItem>
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Chart format')}
                value={state.item.settings.chart_format || ''}
                onChange={(e) =>
                    handleChangeSettings('chart_format', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="line">{kedo.t('Line')}</MenuItem>
                <MenuItem value="bar">{kedo.t('Bar')}</MenuItem>
                <MenuItem value="pie">{kedo.t('Pie')}</MenuItem>
                <MenuItem value="table">{kedo.t('Table')}</MenuItem>
            </TextField>
            {state.item.settings.chart_format === 'bar' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Group format')}
                    value={state.item.settings.group_format || ''}
                    onChange={(e) =>
                        handleChangeSettings('group_format', e.target.value)
                    }
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="grouped">{kedo.t('Grouped')}</MenuItem>
                    <MenuItem value="stacked">{kedo.t('Stacked')}</MenuItem>
                </TextField>
            ) : null}
            {state.item.settings.chart_format === 'bar' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Chart layout')}
                    value={state.item.settings.chart_layout || ''}
                    onChange={(e) =>
                        handleChangeSettings('chart_layout', e.target.value)
                    }
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="vertical">{kedo.t('Vertical')}</MenuItem>
                    <MenuItem value="horizontal">
                        {kedo.t('Horizontal')}
                    </MenuItem>
                </TextField>
            ) : null}
            {state.item.settings.chart_format === 'table' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Table layout')}
                    value={state.item.settings.table_layout || ''}
                    onChange={(e) =>
                        handleChangeSettings('table_layout', e.target.value)
                    }
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="ver1">
                        {kedo.t('Version 1 (Martinique header)')}
                    </MenuItem>
                    <MenuItem value="ver2">
                        {kedo.t('Version 2 (Dark header/green striped')}
                    </MenuItem>
                    <MenuItem value="ver3">
                        {kedo.t('Version 3 (Havelock Blue)')}
                    </MenuItem>
                    <MenuItem value="ver4">
                        {kedo.t('Version 4 (Red)')}
                    </MenuItem>
                    <MenuItem value="ver5">
                        {kedo.t('Version 5 (Dark header/light blue striped)')}
                    </MenuItem>
                    <MenuItem value="ver6">
                        {kedo.t('Version 6 (Purple)')}
                    </MenuItem>
                </TextField>
            ) : null}
            {state.item.settings.chart_format === 'table' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Reverse axis')}
                    value={state.item.settings.reverse_axis || ''}
                    onChange={(e) =>
                        handleChangeSettings('reverse_axis', e.target.value)
                    }
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="no">{kedo.t('no')}</MenuItem>
                    <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                </TextField>
            ) : null}
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Enable Label')}
                value={state.item.settings.enable_labels || ''}
                onChange={(e) =>
                    handleChangeSettings('enable_labels', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Enable Grid')}
                value={state.item.settings.enable_grid || ''}
                onChange={(e) =>
                    handleChangeSettings('enable_grid', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Show Y scrollbars')}
                value={state.item.settings.show_y_scroll || ''}
                onChange={(e) =>
                    handleChangeSettings('show_y_scroll', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Reverse axis')}
                value={state.item.settings.reverse_axis || ''}
                onChange={(e) =>
                    handleChangeSettings('reverse_axis', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Legend direction')}
                value={state.item.settings.legend_direction || ''}
                onChange={(e) =>
                    handleChangeSettings('legend_direction', e.target.value)
                }
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="left-to-right">
                    {kedo.t('left-to-right')}
                </MenuItem>
                <MenuItem value="right-to-left">
                    {kedo.t('right-to-left')}
                </MenuItem>
                <MenuItem value="top-to-bottom">
                    {kedo.t('top-to-bottom')}
                </MenuItem>
                <MenuItem value="bottom-to-top">
                    {kedo.t('bottom-to-top')}
                </MenuItem>
            </TextField>
        </Box>
    )
}
